import { Container, EditorialList, SectionHeading } from '@/components/ui'

const ITEMS = [
  {
    title: 'AI-First Curriculum',
    body: 'Tích hợp AI vào mọi quy trình phân tích và phát triển sản phẩm thực tế.',
  },
  {
    title: 'Học qua Dự án thực tế',
    body: 'Không chỉ lý thuyết. Bạn trực tiếp tham gia xây dựng sản phẩm từ con số 0 với sự hỗ trợ của Mentor chuyên nghiệp — case study, chữa bài, kèm cặp.',
  },
  {
    title: 'Cộng đồng Networking',
    body: 'Kết nối với 1.500+ học viên đang làm việc tại các tập đoàn công nghệ lớn.',
  },
  {
    title: 'Roadmap rõ ràng',
    body: 'Mỗi khóa là một mắt xích — từ BA nền tảng đến API, Database, AI Coding và chứng chỉ.',
  },
]

const EaseWhy = () => {
  return (
    <section className="eh-section" id="why">
      <Container>
        <div className="eh-reveal mb-8 md:mb-10">
          <SectionHeading eyebrow="Why M2MBA" title="Tại sao chọn M2MBA?" level="title" />
        </div>
        <EditorialList items={ITEMS} />
      </Container>
    </section>
  )
}

export default EaseWhy
